import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GroupFormModal from "components/modals/group_form_modal";
import { createGroup, endEditGroups, updateGroups } from "../../store/actions/companies";

export class CompaniesGroupFormModal extends React.Component {
  static propTypes = {
    createGroup: PropTypes.func.isRequired,
    editingGroups: PropTypes.array,
    endEditGroups: PropTypes.func.isRequired,
    selectedCompanyIds: PropTypes.array.isRequired,
    updateGroups: PropTypes.func.isRequired
  }

  isCreating() {
    const { editingGroups } = this.props;
    return editingGroups && editingGroups.length === 1 && !editingGroups[0].id;
  }

  handleGroupsEdit = (groups) => {
    this.props.updateGroups(groups);
  }

  handleGroupCreate = (groups) => {
    this.props.createGroup(groups[0], this.props.selectedCompanyIds);
  };

  render() {
    return (
      <GroupFormModal
        groups={this.props.editingGroups}
        shown={this.props.editingGroups != null}
        onCancel={this.props.endEditGroups}
        onSubmit={this.isCreating() ? this.handleGroupCreate : this.handleGroupsEdit}
      />
    );
  }
}

const mapStateToProps = state => ({
  editingGroups: state.companies.editingGroups,
  selectedCompanyIds: state.selectList.selectedCompanyIds,
});

const mapDispatchToProps = {
  createGroup,
  endEditGroups,
  updateGroups
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesGroupFormModal);
